import { useLocation, matchPath } from 'react-router-dom';
import { BannerAppearance, bannerAppearanceMap } from '../types';
import { AppRoutes } from '@/utils';
import { useMemo } from 'react';

const ALL_APP_ROUTES = Object.values(AppRoutes);

const baseDefaults: BannerAppearance = {
  isSticky: false,
  variant: 'default',
};

/**
 * Resolves banner styling based on current AppRoute configuration.
 * @default { sticky: false, variant: 'default' }
 */
export const usePageBannerConfig = (): BannerAppearance => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const activeEnumRoute = ALL_APP_ROUTES.find(route =>
      matchPath({ path: route, end: !route.includes('*') }, pathname),
    );

    if (!activeEnumRoute) {
      return { ...baseDefaults, hidden: true };
    }

    const configOverride = bannerAppearanceMap[activeEnumRoute];

    return {
      ...baseDefaults,
      ...(configOverride ?? {}),
    };
  }, [pathname]);
};
